module.exports = __webpack_public_path__ + "static/media/xregister.7aadddeb.png";